module.exports = __webpack_public_path__ + "static/media/In_Depth_Hero_Desktop.9db35c9f.png";